function a(t) {
  return t.type === "text" && /\r?\n/.test(t.data) && t.data.trim() === "";
}
export {
  a as default
};
//# sourceMappingURL=index.es19.js.map
